/**
 * Helper function to compute the contiguous segments of the data
 *
 * This code was taken from: https://gist.github.com/pbeshai/b2c4ae410c4ea498a8bbe8ad33bce64e
 *
 * @param {Array} lineData the line data
 * @param {Function} defined function that takes a data point and returns true if
 *    it is defined, false otherwise
 * @param {Function} isNext function that takes the previous data point and the
 *    current one and returns true if the current point is the expected one to
 *    follow the previous, false otherwise.
 * @return {Array} An array of segments (subarrays) of the line data
 */
function computeSegments(lineData, defined = () => true, isNext = () => true) {
  let startNewSegment = true;

  // split into segments of continuous data
  const segments = lineData.reduce(function (segments, d) {
    // skip if this point has no data
    if (!defined(d)) {
      startNewSegment = true;
      return segments;
    }

    // if we are starting a new segment, start it with this point
    if (startNewSegment) {
      segments.push([d]);
      startNewSegment = false;

      // otherwise see if we are adding to the last segment
    } else {
      const lastSegment = segments[segments.length - 1];
      const lastDatum = lastSegment[lastSegment.length - 1];
      // if we expect this point to come next, add it to the segment
      if (isNext(lastDatum, d)) {
        lastSegment.push(d);

        // otherwise create a new segment
      } else {
        segments.push([d]);
      }
    }

    return segments;
  }, []);

  return segments;
}

export default computeSegments;
